module.exports = __webpack_public_path__ + "img/112032.18e47936.png";